// App.jsx
import "react-toastify/dist/ReactToastify.css";
import React, { Fragment, useEffect, useMemo } from "react";
import { ToastContainer } from "react-toastify";
import {
  CheckOutlined,
  ErrorOutline,
  InfoOutlined,
  WarningOutlined,
} from "@mui/icons-material";
import { useTheme } from "@mui/material";
import CssBaseLine from "@mui/material/CssBaseline";

import { homeUrl } from "services/apis.service";
import DataRouter from "./DataRouter"; // Use our DataRouter instead of BrowserRouter
import {
  useTheme as useThemeContext,
  useIsSystemDarkMode,
} from "./ThemeContext";
import UserLicenseLevelModal from "features/Group/components/global/UserLicenseLevelModal";
import ReactGA from "react-ga4";
import { clearStorage } from "utils/clear-storage.util";

if (process.env.REACT_APP_GOOGLE_ANALYTICSID) {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICSID);
}

function App() {
  const { themePref } = useThemeContext();
  const { isSystemDarkMode } = useIsSystemDarkMode();
  const { palette } = useTheme();

  const toastTheme = useMemo(
    () =>
      themePref === "system"
        ? isSystemDarkMode
          ? "dark"
          : "light"
        : themePref,
    [themePref, isSystemDarkMode]
  );

  const messageHandlers = (event) => {
    if (event.data.action === "setSessionStorage") {
      const { key, value } = event.data.payload;
      sessionStorage.setItem(key, value);
      window.location.reload();
    }
    if (event.data.action === "logout") {
      setTimeout(() => {
      clearStorage();
      }, 100);
      console.log("User removed from localStorage");
    }
    if (
      String(window.location.href) ===
      `${window.location.origin}/profile/sooth-admin`
    ) {
      sessionStorage.removeItem("user");
    }
  };

  useEffect(() => {
    window.addEventListener("message", messageHandlers);
    return () => {
      window.removeEventListener("message", messageHandlers);
    };
  }, []);

  return (
    <Fragment>
      <CssBaseLine enableColorScheme />
      <ToastContainer
        position="bottom-left"
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable={50}
        pauseOnHover
        icon={({ type }) => {
          switch (type) {
            case "success":
              return <CheckOutlined sx={{ color: palette.success.main }} />;
            case "info":
              return <InfoOutlined sx={{ color: palette.info.main }} />;
            case "warning":
              return <WarningOutlined sx={{ color: palette.warning.main }} />;
            case "error":
              return <ErrorOutline sx={{ color: palette.error.main }} />;
            default:
              return false;
          }
        }}
        theme={toastTheme}
        stacked
      />
      <DataRouter />
      {/* <UserLicenseLevelModal /> */}
    </Fragment>
  );
}

export default App;
